module.exports = __webpack_public_path__ + "img/hotstyleshow5.984f7c01.jpg";